import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPost } from "./postAPI";
import { updateLike } from "./updateLikeAPI";
import { updatePostSave } from "./updateSaveAPI";

const initialState = {
  post: [],
  isLoading: false,
  isError: false,
  error: "",
};

export const fetchPost = createAsyncThunk("post/fetchPost", async (postId) => {
  const result = await getPost(postId);

  return result;
});

export const updatePostLike = createAsyncThunk("post/updatePostLike", async ({likes, id}) => {
    const result = await updateLike({likes, id});
  
    return result;
  });

  export const savePostToggled = createAsyncThunk("post/savePostToggled", async ({isSaved, id }) => {
    const result = await updatePostSave({isSaved, id});
  
    return result;
  });

const postSlice = createSlice({

  name: "post",
  initialState,
  reducers: {
    postSaveChange: (state) => {
        state.post.isSaved = !state.post.isSaved;
    },
    postLikeChange: (state) => {
        state.post.likes = state.post.likes + 1;
    }
  },
  extraReducers: (Builder) => {
    Builder.addCase(fetchPost.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    })
      .addCase(fetchPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.post = action.payload;
      })
      .addCase(fetchPost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.post = [];
      })
      .addCase(savePostToggled.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
      })
        .addCase(savePostToggled.fulfilled, (state, action) => {
          state.isLoading = false;
          state.post[action.payload.id] = action.payload;
        })
        .addCase(savePostToggled.rejected, (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.error = action.error?.message;
        })
      
  },
});

export default postSlice.reducer;
export const { postSaveChange, postLikeChange } = postSlice.actions;